// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".download-button {\n  bottom: 50px;\n}[dir=ltr] .download-button {\n  right: 40px;\n}[dir=rtl] .download-button {\n  left: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
